import React from "react";
import styled, { css } from "styled-components";
import Section from "@cs/components/src/Section";
import ComponentTypeBadge from "./ComponentTypeBadge";
import {
  componentTypeInfo,
  actionContextOptions,
  // newCustomAction,
  // newWebhook,
  // newSchedule,
  // newMetadataView,
  // newListInput,
} from "./utils";
import Table from "@cs/components/src/Table";

type Value = PluginConfigItem | ScriptConfigItem;
type Component = PluginConfigItem["components"][0] | Value;

interface Props<T extends Value> {
  value: T;
  onChange: (value: T) => void;
}

interface RowProps<T extends Value> extends Props<T> {
  component: Component;
}

const grid = ["1fr", "130px", "1fr", "30px"];

const StyledLink = styled.div`
  display: grid;
  grid-template-columns: ${grid.join(" ")};
  column-gap: 10px;
  align-items: center;
`;

const Title = styled.span<{ $empty?: boolean }>`
  ${(props) =>
    props.$empty &&
    css`
      color: var(--gray200);
    `};
`;

const Context = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 3px 5px;
  border-radius: 2px;
  margin-right: 5px;
  margin-top: 2.5px;
  margin-bottom: 2.5px;
  background-color: var(--dark600);
`;

const ComponentRow = <T extends Value>(props: RowProps<T>) => {
  const { component } = props;
  const { title } = componentTypeInfo(component.type);

  return (
    <StyledLink>
      <Title $empty={!component.title}>
        {component.title || "Unnamed " + title}
      </Title>
      <div>
        <ComponentTypeBadge type={component.type} />
      </div>
      <span>
        {component.type === "custom_action_config"
          ? component.contexts.map((context) => {
              const label =
                actionContextOptions.find((option) => option.value === context)
                  ?.label ?? "Unknown";
              return <Context key={label}>{label}</Context>;
            })
          : ""}
      </span>
      {/* {component.type !== 'iconik_plugin_config' && component.type !== 'iconik_script_config' && (
        <Button
          icon={X}
          iconSize={19}
          type="danger"
          borderless
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            if (config.type === 'iconik_plugin_config') {
              onChange({
                ...config,
                components: config.components.filter((c) => c.id !== component.id),
              });
            }
          }}
        />
      )} */}
    </StyledLink>
  );
};

const ComponentTable = <T extends Value>(props: Props<T>) => {
  const { value: config, onChange } = props;

  let rows: Component[] = [config];
  if (config.type === "iconik_plugin_config") {
    rows = [...rows, ...config.components];
  }

  return (
    <div>
      <Section
        title="Components"
        // buttons={
        //   config.type === 'iconik_plugin_config' ? (
        //     <Select
        //       options={componentOptions}
        //       onChange={({ value }) => {
        //         const component =
        //           value === 'custom_action_config'
        //             ? newCustomAction()
        //             : value === 'webhook_config'
        //             ? newWebhook()
        //             : value === 'schedule_config'
        //             ? newSchedule()
        //             : value === 'metadata_view_config'
        //             ? newMetadataView()
        //             : value === 'list_input_config'
        //             ? newListInput()
        //             : undefined;
        //         if (component) {
        //           const id = component.id;
        //           onChange({
        //             ...config,
        //             components: [...config.components, component],
        //           });
        //           navigate(`component/${id}`);
        //         }
        //       }}
        //       buttonControlProps={{
        //         icon: Plus,
        //         iconSize: 19,
        //       }}
        //     />
        //   ) : undefined
        // }
      >
        <Table
          rows={rows.map((component) => {
            const { section } = componentTypeInfo(component.type);

            return {
              id: component.id,
              link: `${section}${
                component.type !== "iconik_plugin_config" &&
                component.type !== "iconik_script_config"
                  ? "/" + component.id
                  : ""
              }`,
              element: () => (
                <ComponentRow
                  component={component}
                  value={config}
                  onChange={onChange}
                />
              ),
            };
          })}
          autoHeight={{ twoColumn: true }}
        />
      </Section>
    </div>
  );
};

export default ComponentTable;
